import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from '@ui5/webcomponents-react';
import Login from "./screens/acessos/login";
import RedefinirSenha from "./screens/acessos/RedefinirSenha";
import AppLayout from "./components/AppLayout";
import PrivateRoute from "./components/PrivateRoute";
import { AuthProvider } from "./contexts/AuthContext";
import { ToastProvider } from "./components/toast_notification/ToastProvider";
import NovoUsuario from "./screens/cadastros/novo_usuario";
function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <ToastProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/redefinir-senha" element={<RedefinirSenha />} />
            <Route path="/cadastros/novo-usuario" element={<NovoUsuario />} />
            <Route path="/redefinir-senha/:token" element={<RedefinirSenha />} />
            <Route
              path="*"
              element={
                <PrivateRoute>
                  <AppLayout />
                </PrivateRoute>
              }
            />
          </Routes>
        </Router>
        </ToastProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;